import { gql } from "@edreamsodigeo/frontend-api-client";

export const IS_USER_LOGGED_QUERY = gql`
  query IsUserLoggedFromUserAccount($userAccountRequest: UserAccountRequest) {
    userAccount(userAccountRequest: $userAccountRequest) {
      isLoggedIn
    }
  }
`;
